import React from 'react';
import SampleSourceManagementRouter from './SampleSourceManagementRouter';

export default function SampleSourceManagementPage() {
  return <SampleSourceManagementRouter />;
}